import type { ReactNode } from 'react';
import { BrandMark } from '@/components/brand/BrandMark';
import { ThemeToggle } from '@/components/theme/ThemeToggle';

export function AuthLayout({
  title,
  subtitle,
  children,
  footer,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-makhe-bg text-makhe-ink">
      <div className="grid min-h-screen md:grid-cols-12">
        <aside className="brand-wash relative hidden border-r border-makhe-line p-10 md:col-span-5 md:flex md:flex-col md:justify-between">
          <BrandMark size={32} />
          <div>
            <BrandMark lockup to={null} size={320} />
            <p className="mt-6 max-w-xs text-sm leading-relaxed text-makhe-ink/75">
              Students who need a service, and students who do the work.
            </p>
          </div>
          <div className="rule-pattern" aria-hidden />
        </aside>

        <main className="md:col-span-7">
          <div className="mx-auto max-w-md px-6 py-12 md:py-20">
            <div className="flex items-start justify-between gap-4">
              <BrandMark lockup to="/" size={180} className="min-w-0 md:hidden" />
              <ThemeToggle className="ml-auto shrink-0" />
            </div>

            <p className="eyebrow mt-10 md:mt-8">Welcome</p>
            <h1
              className="mt-4 font-display text-4xl leading-tight md:text-5xl"
              style={{ fontVariationSettings: '"opsz" 144, "wght" 400' }}
            >
              {title}
            </h1>
            {subtitle && (
              <p className="mt-3 max-w-sm text-makhe-ink/70">{subtitle}</p>
            )}
            <div className="mt-10 space-y-5">{children}</div>
            {footer && (
              <div className="mt-8 text-sm text-makhe-muted">{footer}</div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
